import AppConstants from '../config/app.constants';

let AtmResidualDepositService = function ($http, $q) {

    // let all = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPendingDeposit = (branchId, fundingSourceId, currencyId, account, vaultDate) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/get-pending-deposit`, {
    //             branchId,
    //             fundingSourceId,
    //             currencyId,
    //             account,
    //             vaultDate,
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let commitDeposit = (branchId, fundingSourceId, bulkCashData, orderNumber, trackingId, vaultDate, totalAmount, carrierId, userId, currencyId) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/commit-atm-deposit`, {
    //             branchId,
    //             fundingSourceId,
    //             bulkCashData,
    //             orderNumber,
    //             trackingId,
    //             vaultDate,
    //             totalAmount,
    //             carrierId,
    //             userId,
    //             currencyId
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPackedResidualDeposit = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit/get-packed-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    // let getShipmentsDenomination = (branchId, account, toLocationId) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/get-shipments-denomination`, {
    //             branchId,
    //             account,
    //             toLocationId
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let shipDepositPacking = (shippingData) => {
    //     return $http
    //         .post(AppConstants.api + `/atm-residual-deposit/ship-deposit-packing`, {
    //             shippingData
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // };

    // let getPendingResidualDeposit = (search, offset, limit) => {
    //     return $http
    //         .get(AppConstants.api + `/atm-residual-deposit/pending-residual-deposit`, {
    //             params: {
    //                 search,
    //                 offset,
    //                 limit
    //             }
    //         })
    //         .then((res) => {
    //             return res.data
    //         })
    // }

    let getPendingResidualDeposit = (branchId, fundingLocationId, fundingSourceId, currencyId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/residuals-pending`, {
                params: {
                    branchId,
                    fundingLocationId,
                    fundingSourceId,
                    currencyId,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let commitDeposit = (branchId, fundingLocationId, fundingSourceId, currencyId, trackingId, account, carrierId, userId, residualIds, toLocationId, routeId, deliveryDate) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack`, {
                branchId,
                fundingLocationId,
                fundingSourceId,
                currencyId,
                trackingId,
                account,
                carrierId,
                userId,
                residualIds,
                toLocationId,
                routeId,
                deliveryDate
            })
            .then((res) => {
                return res.data
            })
    };

    let residualPackPreview = (branchId, fundingLocationId, fundingSourceId, currencyId, trackingId, residualIds) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack-preview`, {
                branchId,
                fundingLocationId,
                fundingSourceId,
                currencyId,
                trackingId,
                residualIds
            })
            .then((res) => {
                return res.data
            })
    }

    let getPendingRelease = (branchId, fundingLocationId, currencyId, account, carrierId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/pending-release`, {
                params: {
                    branchId,
                    fundingLocationId,
                    currencyId,
                    account,
                    carrierId,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let contents = (depositId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/contents`, {
                params: {
                    depositId,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let release = (depositId, isResidualDeposit, branchId, depositTrackingId, carrierId, carrierName, userId) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/release`, {
                depositId,
                isResidualDeposit,
                branchId,
                depositTrackingId, 
                carrierId, 
                carrierName, 
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let released = (branchId, fundingLocationId, currencyId, account, carrierId, startDate, endDate, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/released`, {
                params: {
                    branchId,
                    fundingLocationId,
                    currencyId,
                    account,
                    carrierId,
                    startDate,
                    endDate,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let emergencyPackPreview = (branchId, fundingLocationId, currencyId) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack-preview/emergency`, {
                branchId,
                fundingLocationId,
                currencyId
            })
            .then((res) => {
                return res.data
            })
    }

    let commitEmergencyDeposit = (branchId, fundingLocationId, currencyId, trackingId, carrierId, userId, toLocationId, routeId, deliveryDate) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack/emergency`, {
                branchId,
                fundingLocationId,
                currencyId,
                trackingId,
                carrierId,
                userId,
                toLocationId,
                routeId,
                deliveryDate
            })
            .then((res) => {
                return res.data
            })
    };

    let exportPendingPackData = (branchId, fundingLocationId, fundingSourceId, currencyId, currencySymbol, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/export-pending-pack`, {
                params: {
                    branchId,
                    fundingLocationId,
                    fundingSourceId,
                    currencyId,
                    currencySymbol,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportPackedResidualData = (branchId, fundingLocationId, currencyId, currencySymbol, account, carrierId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/export-packed-residual`, {
                params: {
                    branchId,
                    fundingLocationId,
                    currencyId,
                    currencySymbol,
                    account,
                    carrierId,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let exportReleasedResidualData = (branchId, fundingLocationId, currencyId, currencySymbol, account, carrierId, startDate, endDate, limit, offset) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/export-released-residual`, {
                params: {
                    branchId,
                    fundingLocationId,
                    currencyId,
                    currencySymbol,
                    account,
                    carrierId,
                    startDate,
                    endDate,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let undoDepositPack = (depositId, force) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/undo`, {
                depositId,
                force
            })
            .then((res) => {
                return res.data
            })
    }

    let adHocPackPreview = (branchId, fundingLocationId, currencyId, account, amounts) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack-preview/adhoc`, {
                branchId,
                fundingLocationId,
                currencyId,
                account,
                amounts
            })
            .then((res) => {
                return res.data
            })
    }

    let adHocPack = (branchId, fundingLocationId, currencyId, account, carrierId, userId, deposits, toLocationId, routeId, deliveryDate) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/pack/adhoc`, {
                branchId,
                fundingLocationId,
                currencyId,
                account,
                carrierId,
                userId,
                deposits,
                toLocationId,
                routeId,
                deliveryDate
            })
            .then((res) => {
                return res.data
            })
    }

    let ledgerDenomBalance = (branchId, account, fundingLocationId) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/ledger-denom-balance`, {
                branchId,
                account,
                fundingLocationId
            })
            .then((res) => {
                return res.data
            })
    }

    let ledgerDenomBalanceFundingSource = (branchId, account, fundingLocationId) => {
        const params = {
            branchId,
            account
        };
        
        // Add fundingLocationId if provided for BFS filtering
        if (fundingLocationId) {
            params.fundingLocationId = fundingLocationId;
        }
        
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/ledger-denom-balance-funding-source`, params)
            .then((res) => {
                return res.data
            })
    }

    let exportReleasedDeposit = (depositId) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/export-released-deposit`, {
                params: {
                    depositId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let commitDepositCount = (fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, 
                              countedByUserId, declaredTotalAmount, countedVariance, supervisorId, browserTimezone, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount, notes) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/deposit-count-commit`, {
            fundingSource,
            trackingId,
            comment,
            notes,
            denomsData,
            branchId,
            pickupDate,
            pickupTime,
            branchTimeZone,
            countedByUserId,
            declaredTotalAmount,
            countedVariance,
            supervisorId,
            browserTimezone,
            monthlySupervisorId,
            monthlyCashCountLimitAmount,
            totalCountedThisMonth,
            newCountAmount
        }).then((res) => {
            return res.data
        })
    }

    let editDepositCount = (fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, 
                            countedByUserId, depositId, declaredTotalAmount, countedVariance, supervisorId, browserTimezone, monthlySupervisorId, monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount, notes) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/deposit-count-edit`, {
            fundingSource,
            trackingId,
            comment,
            notes,
            denomsData,
            branchId,
            pickupDate,
            pickupTime,
            branchTimeZone,
            countedByUserId,
            depositId,
            declaredTotalAmount,
            countedVariance,
            supervisorId,
            browserTimezone,
            monthlySupervisorId,
            monthlyCashCountLimitAmount, totalCountedThisMonth, newCountAmount
        }).then((res) => {
            return res.data
        })
    }

    let getDepositShipmentRecord = (trackingId, fundingSource) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/get-deposit-shipment`, {
            trackingId,
        }).then((res) => {
            return res.data
        })
    }

    let createResidualDepositShipment = (residualTrackingId) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/create-residual-deposit-shipment`, {
                residualTrackingId
            })
            .then((res) => res.data);
    }

    let getBulkDepositShipmentRecord = (trackingId, fundingSource) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/get-bulk-deposit-shipment`, {
            trackingId,
            fundingSource
        }).then((res) => {
            return res.data
        })
    }

    let createIndividualBagShipment = (bulkDepositTrackingId, bagTrackingId, declaredAmount, userId) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/create-individual-bag-shipment`, {
            bulkDepositTrackingId,
            bagTrackingId,
            declaredAmount,
            userId
        }).then((res) => {
            return res.data
        })
    }

    let finalizeBulkDeposit = (trackingId, userId) => {
        return $http
        .post(AppConstants.api + `/atm-residual-deposit/finalize-bulk-deposit`, {
            trackingId,
            userId
        }).then((res) => {
            return res.data
        })
    }

    let reopenBulkDeposit = (trackingId, userId) => {
        return $http
            .post(AppConstants.api + `/atm-residual-deposit/reopen-bulk-deposit`, {
                trackingId,
                userId
            }).then((res) => {
                return res.data
            })
    }

    let getMonthlyCountCheck = (locationId, newCountAmount, branchId, month, shiptype) => {
        return $http
            .get(AppConstants.api + `/atm-residual-deposit/monthly-count-check`, {
                params: {
                    locationId,
                    newCountAmount: Number((newCountAmount || 0).toFixed(2)),
                    branchId,
                    month,
                    shiptype
                }
            })
            .then((res) => {
                return res.data;
            });
    }


    return {
        // all,
        // getPendingDeposit,
        // getPackedResidualDeposit,
        // getShipmentsDenomination,
        residualPackPreview,
        getPendingResidualDeposit,
        commitDeposit,
        getPendingRelease,
        contents,
        release,
        released,
        emergencyPackPreview,
        commitEmergencyDeposit,
        exportPendingPackData,
        exportPackedResidualData,
        exportReleasedResidualData,
        undoDepositPack,
        adHocPackPreview,
        adHocPack,
        ledgerDenomBalance,
        exportReleasedDeposit,
        ledgerDenomBalanceFundingSource,
        commitDepositCount,
        getDepositShipmentRecord,
        createResidualDepositShipment,
        getBulkDepositShipmentRecord,
        createIndividualBagShipment,
        finalizeBulkDeposit,
        editDepositCount,
        reopenBulkDeposit,
        getMonthlyCountCheck
    };

};

AtmResidualDepositService.$inject = ['$http', '$q']

export default AtmResidualDepositService;






// WEBPACK FOOTER //
// ./client/app/services/atm-residual-deposit.service.js